import { MaintenanceDto, MaintenanceReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type MaintenanceDtoAny = MaintenanceDto | MaintenanceReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type MaintenanceDtoAll = MaintenanceDto & MaintenanceReferenceDto;

export class MaintenanceMapper {}
